import React from "react"
import { Card } from "react-bootstrap"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
const commissions = () => {
  return (
    <Layout>
      <Helmet>
        <title>Commissions - Pamela Mary Brown</title>
      </Helmet>
      <h2>Commissions</h2>
      <Card style={{ border: "none", backgroundColor: "transparent" }}>
        <Card.Title style={{ marginTop: "10px" }}>
        Staying Here
        </Card.Title>
        <Card.Text style={{ marginBottom: "10px" }}>
        I am pleased to share the trailer for “Neon Saints”, a short film produced in collaboration with the Community Arts Partnership, the Belfast Film Academy, and Lamb Films, with generous support from the Community Foundation for NI Social Justice Programme and the Esme Mitchell Trust.
        </Card.Text>
        <Card.Text style={{ marginBottom: "10px" }}>
        Serving as lead facilitator (alongside Dr. Tony McCauley) and co-writer (alongside Nicole Lee Jiaqi), we worked with 18 participants aged 17–25 from the South Belfast area. Through a series of weekly workshops from September to November 2025, we shared and explored personal stories that informed the film's narrative arc, creative direction, and script.
        </Card.Text>
      </Card>
      <div style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
  <video 
    controls 
    muted 
    loop
    playsInline
    poster="/videos/posterimage.png"  
    style={{ 
      width: "100%", 
      height: "auto", 
      display: "block" 
    }}
  >
    <source src="/videos/video1.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
<hr style={{ background: "black" }} />
      <Card style={{ border: "none", backgroundColor: "transparent" }}>
        <Card.Title style={{ marginTop: "10px" }}>
          O City, City on the Foyle
        </Card.Title>
        <Card.Text style={{ marginBottom: "10px" }}>
          This was a commission to write a public poem for the Derry City and
          Strabane Heritage Council. Spoken Word Poem and Voiceover.
        </Card.Text>
      </Card>
      <div className="video-style" style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
        <iframe
          width="100%"
          height="350"
          src="https://www.youtube.com/embed/40oxaSmW35A"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <hr style={{ background: "black" }} />
      <Card style={{ border: "none", backgroundColor: "transparent" }}>
        <Card.Title style={{ marginTop: "10px" }}>
          2020 A Taste of LegenDerry Advert
        </Card.Title>
        <Card.Text style={{ marginBottom: "10px" }}>
          Writer: Spoken Word Poem.
        </Card.Text>
      </Card>
      <div className="video-style" style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
        <iframe
          width="100%"
          height="350"
          src="https://www.youtube.com/embed/bUrPCw9kbrI"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <hr style={{ background: "black" }} />
      <Card style={{ border: "none", backgroundColor: "transparent" }}>
        <Card.Title style={{ marginTop: "10px" }}>The Fag (2009)</Card.Title>
        <div className="video-style" style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
          <iframe
            width="100%"
            height="350"
            src="https://www.youtube.com/embed/oPHy8IYJG54/?showinfo=0"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <Card.Text>
          Winner of the Scanbitz Short Film Challenge, Clones Film Festival,
          receiving the Audience Award and Francie Trophy (named after ‘Francie
          Brady’, author Pat McCabe’s protagonist in The Butchers Boy).
        </Card.Text>
        <Card.Text>
          The challenge was to cast, rehearse, scout locations, shoot and edit a
          short film in 48 hours.
        </Card.Text>

        <Card.Text>
          For more information visit
          <a
            href="https://clonesfilmfestival.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            clonesfilmfestival.com
          </a>
        </Card.Text>
      </Card>
    </Layout>
  )
}

export default commissions
